import React from 'react';

import { PortalConfigContext, RouteContext } from 'src/context';
import { useSettingsVisibilityContext } from 'src/features/settings/registry/useSettingsVisibilityContext';
import { getClientSettingsTerm } from 'src/utils/clientSettingsPaths';

import { SettingsSidebarRow } from './SettingsSidebarRow';
import { getSettingsSidebarSections } from './settingsSidebarSections';
import { useSettingsSidebarNavigate } from './useSettingsSidebarNavigate';

/** The settings sidebar's sections and rows under `new-settings`, read from the registry. */
export const SettingsSidebarNav = () => {
  const ctx = useSettingsVisibilityContext();
  const { pathname } = React.useContext(RouteContext);
  const { features } = React.useContext(PortalConfigContext);
  const onSelect = useSettingsSidebarNavigate();

  const sections = getSettingsSidebarSections({
    ctx,
    clientTerm: getClientSettingsTerm(features.customLabels),
    pathname,
  });

  return (
    <nav aria-label="Settings" className="pb-6">
      {sections.map((section) => (
        <div key={section.id} data-testid={`section-${section.id}-settings`}>
          <div className="px-[18px] pt-3 pb-1 text-[11px] font-medium tracking-[0.01em] text-secondary">
            {section.title}
          </div>
          <div className="flex flex-col gap-px px-2.5">
            {section.rows.map((row) => (
              <SettingsSidebarRow key={row.id} row={row} onSelect={onSelect} />
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
};
